let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cn5xt")).then(() => parcelRequire('14NkX'));